/*
 * @Author: your name
 * @Date: 2021-09-26 21:29:54
 * @LastEditTime: 2024-07-03 09:38:19
 * @LastEditors: lbb lhz6887@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \h5-vip\src\store\index.js
 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        code: '',
        referKey: '',
        token: localStorage.getItem('token') || '',
        merchartInfo: {},
        // 商户端办卡信息
        merchantCardInfo: JSON.parse(localStorage.getItem('merchantCardInfo')) || {},
    },
    getters: {
        getToken(state, getters) {
            //getter相当于计算属性 获取state的值
            return state.token;
        },
    },
    mutations: {
        saveToken(state, data) {
            localStorage.setItem('token', data);
            state.token = data;
        },
        // 保存 银行编码
        saveCode(state, code) {
            state.code = code;
        },
        // 保存邀请码
        saveReferKey(state, referKey) {
            state.referKey = referKey;
        },
        // 一键注册商户信息
        setMerchart(state, data) {
            state.merchartInfo = data;
        },
        // 商户端办卡信息
        setMerchantCardInfo(state, data) {
            localStorage.setItem('merchantCardInfo', JSON.stringify(data));
            state.merchantCardInfo = data;
        },
    },
});
